import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'input-number-effect',
  templateUrl: './input-effect.component.html',
  styleUrls: ['./input-effect.component.scss'],
  providers: [],
})
export class InputNumberEffectComponent implements OnInit, OnDestroy {
  @ViewChild('myInput') inputElement!: ElementRef<HTMLInputElement>;
  @Output() newValue: EventEmitter<string> = new EventEmitter<string>();
  @Output() rawValueEmitted: EventEmitter<string> = new EventEmitter<string>();
  @Input() showLabel = false;
  @Input() initial: string | number = '0.00';
  @Input() title = 'Value';
  @Input() isNegativeAllowed = true;
  @Input() fromOwnership;
  @Input() fromPurchasePrice;
  @Input() fromAddBalance;
  @Input() fromRegister;
  @Input() fromPrivateDebt;
  @Input() styledIcon = false;
  @Input() hideIcons = false;
  @Input() isCounter = false;
  @Input() disableInput = false;
  @Input() fromRolePlayers = false;
  @Input() tabIndex = 0;
  @Input() floatLabel = 'auto';
  @Input() formControlName;
  @Input() control;
  @Input() imgSource;
  @Input() tooltipText;
  @Input() fromBalanceAlert;
  @Input() dynamicControl = false;
  isNegative = false;
  isCursorChanged = false;
  isDisabled = false;
  isAndroid = false;
  @Input() focusId = '';
  @Input() fromTotalCommitment = false;
  public valueChanges = new Subject<string>();
  sub: Subscription = new Subscription();
  @Input() allowMoreThanTwoDecimal = true;
  constructor() {
    this.sub.add(
      this.valueChanges.pipe(debounceTime(this.allowMoreThanTwoDecimal ? 600 : 100)).subscribe((value) => {
        this.initial = this.addCommas(value);
        this.newValue.emit(this.initial);
      })
    );
  }

  ngOnInit(): void {
    this.initial = this.formatMoneyFix(this.initial);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  formatMoneyFix(value) {
    // Handle null, undefined, or non-numeric inputs
    if (value == null) return '';

    // Convert to number and handle potential invalid inputs
    const number = Number(value);

    // Return original input if not a valid number
    if (isNaN(number)) return String(value);
    // Use toLocaleString for locale-aware number formatting

    return number.toLocaleString('en-US', {
      minimumFractionDigits: this.allowMoreThanTwoDecimal ? 8 : 2,
      maximumFractionDigits: this.allowMoreThanTwoDecimal ? 8 : 2,
    });
  }

  setInputValue(value: string | number) {
    this.initial = this.formatMoneyFix(value);
    this.newValue.emit(this.initial);
  }

  onModelChange(value) {
    if (this.fromRolePlayers) {
      this.rawValueEmitted.emit(value);
    }
  }

  selectAll() {
    // We will activate this if we later intend to create selection on user click
    // const dialogEl = this.inputElement?.nativeElement;
    // setTimeout(() => {
    //   dialogEl.setSelectionRange(0, dialogEl.value.length); // Highlight the value
    // }, 100);
  }

  addCommas(value: string) {
    const numericValue = value.replace(/,/g, '');

    if (numericValue === '.' || numericValue === '-.' || numericValue === '-') {
      return numericValue;
    }

    if (isNaN(Number(numericValue))) return '';

    let [integerPart, decimalPart] = numericValue.split('.');

    // Limit decimal digits to 2
    if (decimalPart && decimalPart.length > 2 && !this.allowMoreThanTwoDecimal) {
      decimalPart = decimalPart.substring(0, 2);
    } else if (decimalPart && decimalPart.length > 2 && this.allowMoreThanTwoDecimal) {
      decimalPart = decimalPart.substring(0, 8);
    }

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
  }
}
